<template>
    <div class="forgot-password">

        <page-loader :loading="loading"/>
        <div>
            hfrteiufreiua;
        </div>
        <full-screen-dialog
            header-back-button-disabled
            header-close-button-disabled
        >
            <div v-if="!loading" class="container forgot-password-container">
                <confirm-email
                    v-if="activeStep === 'email'"
                    :value="credentials"
                    :errors="errors.email"
                    @submit="submitEmail"
                />
                <email-sent
                    :accountUnfinished="accountUnfinished"
                    v-else-if="activeStep === 'emailSent'"
                />
                <confirm-password
                    v-else-if="activeStep === 'resetPassword'"
                    :value="credentials"
                    :errors="errors"
                    @submit="submitPassword"
                />
            </div>
        </full-screen-dialog>
    </div>
</template>

<script>
import "./ForgotPassword.scss";
import ConfirmEmail from "./ConfirmEmail/ConfirmEmail";
import EmailSent from "./EmailSent/EmailSent";
import ConfirmPassword from "../Auth/Steps/ConfirmPassword/ConfirmPasswordStep";
import FullScreenDialog from "@components/dialogs/FullScreenDialog/FullScreenDialog";
import FrontEndApiService from "@services/frontend.api.service";
import {mapActions} from 'pinia';
import {useAuthStore} from '@store';
import {runAsPublic} from "@helpers/api-helper";

const STEPS = {
    email: 'email',
    emailSent: 'emailSent',
    resetPassword: 'resetPassword',
}

export default {
    name: "ForgotPassword",
    components: {
        FullScreenDialog,
        ConfirmPassword,
        ConfirmEmail,
        EmailSent,

    },
    props: {
        accountUnfinished: {
            required: false,
            default: false
        },
        email: {
            required: false
        }
    },
    data: () => ({
        activeStep: STEPS.email,
        refreshPasswordToken: null,
        credentials: {
            email: '',
            password: '',
            confirmPassword: '',
            userAgreementAccepted: false,
        },
        errors: {
            email: [],
            password: [],
            confirmPassword: [],
        },
        loading: true,
    }),
    computed: {},
    methods: {
        ...mapActions(useAuthStore, {
            login: 'login',
            register: 'register',
        }),
        clearErrors() {
            this.errors = {
                email: [],
                password: [],
                confirmPassword: [],
            };
        },
        isValidEmail(email) {
            if (!email) {
                return false;
            }
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        async submitEmail() {
            this.clearErrors();
            let {email} = this.credentials;

            if (this.accountUnfinished && this.email) {
                email = this.email;
            }

            if (!email || !this.isValidEmail(email)) {
                this.errors.email.push('Please enter a valid email address');
                return;
            }

            return await runAsPublic(async (config) => {

                const sendForgotPasswordEmailData = {
                    email,
                };

                const response = await FrontEndApiService.post(`${config.apiPrefix}/v1/user/send-password-recovery-mail`, sendForgotPasswordEmailData);

                if (response.status !== 200) {
                    console.warn("Error submitting email", error);
                    this.errors.email.push('The email address does not exist');
                    throw "Invalid email";
                }

                this.activeStep = STEPS.emailSent;

            });
        },
        async submitPassword() {
            this.clearErrors();
            const {password, confirmPassword} = this.credentials;

            if (password !== confirmPassword) {
                this.errors.password.push("Passwords need to match");
                this.errors.confirmPassword.push("Passwords need to match");
                return;
            }

            return await runAsPublic(async (config) => {
                const resetPasswordData = {
                    password,
                    resetPasswordToken: this.refreshPasswordToken,
                }

                const response = await FrontEndApiService.post(`${config.apiPrefix}/v1/user/reset-password`, resetPasswordData);

                if (response.status !== 200) {
                    console.warn("Error submitting password", error);
                    this.errors.password.push('Token not found or is expired');
                    throw "Token not found or is expired";
                }

                await this.$router.push({name: 'auth'});
            });
        },
    },
    async created() {
        if (this.accountUnfinished && !!this.email) {
            await this.submitEmail();
        }

        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        this.refreshPasswordToken = token;

        if (token) {
            this.activeStep = STEPS.resetPassword;
        }

        this.loading = false;
    }
}
</script>